import { useMutation, useQueryClient } from '@tanstack/react-query';
import { LegalApi } from '../../../apis/LegalApi/LegalApi.ts';
import { ILegalAcceptanceResponse, IRecordLegalAcceptance } from '../Legal.ts';
import { QueryKeys } from '../../../queryDefaults/QueryKeys.ts';
import { AppMedError } from '../../../error/AppMedError.ts';

export function usePostAcceptLegalDocument() {
    const queryClient = useQueryClient();

    return useMutation<ILegalAcceptanceResponse, AppMedError, IRecordLegalAcceptance>({
        mutationFn: async (data) => {
            return LegalApi.accept(data);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QueryKeys.legalRequirements] });
        },
        onError: (error) => {
            console.error('Failed to record legal acceptance:', error.message);
        },
    });
}
